import {
  Card,
  CardContent as MuiCardContent,
  Typography,
  Box,
  styled,
} from '@mui/material'
import ArrowUpwardIcon from '@mui/icons-material/NorthEast'
import ArrowDownwardIcon from '@mui/icons-material/SouthEast'

interface CodeValidationSummaryProps {
  title: string
  value: string
  icon?: React.ReactNode
  description?: string
  previousYearVariance?: number // value to determine trend
}

const CardContent = styled(MuiCardContent)(({ theme }) => ({
  padding: 0,
  paddingBottom: 0,
  height: '100%',
}))

const CodeValidationSummary = ({
  title,
  value,
  icon,
  description,
  previousYearVariance,
  sx,
}: CodeValidationSummaryProps & { sx?: any }) => {
  // Determine trend based on previousYearVariance
  let trend: 'up' | 'down' | undefined = undefined
  if (typeof previousYearVariance === 'number') {
    if (previousYearVariance > 0) trend = 'up'
    else if (previousYearVariance < 0) trend = 'down'
  }

  return (
    <Card sx={{ background: 'transparent', ...sx }}>
      <CardContent>
        {/* First Row: Title */}
        <Box display='flex' justifyContent='center' alignItems='center'>
          <Typography fontSize={10} fontWeight={600} color='#FFFFFF'>
            {title}
          </Typography>
        </Box>
        {/* Second Row: Static Loader Icon and Value */}
        <Box display='flex' justifyContent='center' alignItems='center' gap={1}>
          <Box
            component='img'
            src='/images/loading.png'
            alt='loader'
            sx={{ width: 32, height: 32 }}
          />
          <Typography fontSize={33} fontWeight={700} color='#FFFFFF'>
            {typeof value === 'number' ? `${value}%` : value}
          </Typography>
        </Box>
        {/* Third Row: Description (conditionally rendered) with up/down arrow */}
        {description && (
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            gap={0.5}
            paddingBottom={0}
          >
            {trend === 'up' && (
              <ArrowUpwardIcon sx={{ fontSize: 10, color: '#FFFFFF' }} />
            )}
            {trend === 'down' && (
              <ArrowDownwardIcon sx={{ fontSize: 10, color: '#FFFFFF' }} />
            )}
            <Typography fontSize={7} color='#FFFFFF' textAlign='center'>
              {description}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  )
}

export default CodeValidationSummary
